import "./SourcingRequestForm.css";
import React, { useState } from "react";


export default function SourcingRequestForm() {

 const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // here you can also send data to backend API
    setShowPopup(true);

    // auto close popup after 3 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };



  return (
    <div className="sourcing-container">
      <header className="sourcing-header">
        <h2>🔧 Ultimate Sourcing Request Form</h2>
        <p>Please fill out all the required details for accurate sourcing.</p>
      </header>

      {/* 1. Basic Contact Details */}
      <section className="sourcing-section">
        <h3>🧑‍💼 1. Basic Contact Details</h3>
        <div className="sourcing-grid">
          <input placeholder="Full Name *" required />
          <input type="email" placeholder="Email *" required />
          <input placeholder="Phone Number (with Country Code) *" required />
          <input placeholder="Company Name (if applicable)" />
          <input placeholder="Country of Residence / Business *" required />
        </div>
      </section>

      {/* 2. Product Details */}
      <section className="sourcing-section">
        <h3>📦 2. Product Details</h3>
        <div className="sourcing-grid">
          <input placeholder="Product Name *" required />
          <textarea placeholder="Brief Description *" required></textarea>
          <select>
            <option>Category / Industry *</option>
            <option>Food</option>
            <option>Textiles</option>
            <option>Herbal</option>
            <option>Furniture</option>
            <option>Handicrafts</option>
            <option>Industrial</option>
            <option>Other</option>
          </select>
          <input placeholder="Target Use / Application" />
        </div>
      </section>

      {/* 3. Specifications */}
      <section className="sourcing-section">
        <h3>📐 3. Specifications</h3>
        <div className="sourcing-grid">
          <input placeholder="Material Required" />
          <input placeholder="Size / Dimensions" />
          <input placeholder="Weight" />
          <input placeholder="Color Preferences" />
          <input placeholder="Quality Certifications Needed (ISO, FSSAI, etc.)" />
          <label className="upload-box">
            Reference Images / Documents
            <input type="file" accept=".pdf,.jpg,.jpeg,.png" multiple />
          </label>
        </div>
      </section>

      {/* 4. Quantity & Packaging */}
      <section className="sourcing-section">
        <h3>🎯 4. Quantity & Packaging</h3>
        <div className="sourcing-grid">
          <input placeholder="Minimum Order Quantity (MOQ)" />
          <input placeholder="Expected Total Order Volume" />
          <input placeholder="Packaging Requirements (Bulk, Retail, Custom Branding, Eco-friendly, etc.)" />
        </div>
      </section>

      {/* 5. Delivery & Logistics */}
      <section className="sourcing-section">
        <h3>🚢 5. Delivery & Logistics</h3>
        <div className="sourcing-grid">
          <input placeholder="Preferred Shipping Terms (FOB, CIF, EXW, DDP, etc.)" />
          <input placeholder="Destination Country / Port" />
          <input placeholder="Preferred Delivery Timeframe" />
          <textarea placeholder="Customs Requirements / Restrictions (if any)"></textarea>
        </div>
      </section>

      {/* 6. Budget & Pricing */}
      <section className="sourcing-section">
        <h3>💰 6. Budget & Pricing</h3>
        <div className="sourcing-grid">
          <input placeholder="Target Price Per Unit (Optional)" />
          <input placeholder="Overall Budget Range" />
        </div>
      </section>

      {/* 7. Branding & Private Label */}
      <section className="sourcing-section">
        <h3>🧾 7. Branding & Private Label</h3>
        <div className="sourcing-grid">
          <label>
            Do you want custom branding/private label? <br />
            <span>
              <input type="radio" name="branding" /> Yes
              <input type="radio" name="branding" /> No
            </span>
          </label>
          <label className="upload-box">
            Upload Logo (if yes)
            <input type="file" accept=".png,.jpg,.jpeg,.svg" />
          </label>
          <textarea placeholder="Label or Packaging Design Requirements"></textarea>
        </div>
      </section>

      {/* 8. Additional Info */}
      <section className="sourcing-section">
        <h3>🧠 8. Additional Information</h3>
        <div className="sourcing-grid">
          <textarea placeholder="Any Additional Notes or Requirements?"></textarea>
          <label>
            Have you worked with Indian suppliers before?
            <span>
              <input type="radio" name="suppliers" /> Yes
              <input type="radio" name="suppliers" /> No
            </span>
          </label>
          <label>
            Would you like product samples first?
            <span>
              <input type="radio" name="samples" /> Yes
              <input type="radio" name="samples" /> No
            </span>
          </label>
        </div>
      </section>

      {/* 9. Consent */}
      <section className="sourcing-section-consent">
       
        <label className="consent">
          <input type="checkbox" required /> I agree to be contacted by Indvo
          regarding my sourcing request.
        </label>
      </section>

      <button className="sourcing-submit-btn">Submit Request</button>


       {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>✅ Your request has been received!</h3>
            <p>Our team will get back to you shortly.</p>
            <button onClick={() => setShowPopup(false)} className="popup-close">
              Close
            </button>
          </div>
        </div>
      )}
    </div>

    


  );
}
